export default data => ({
    type: 'SET_PROJECTS_ARCHIVE_DATA',
    payload: data
})



// WEBPACK FOOTER //
// ./src/scripts/actions/setAllProjectsArchiveData.js